module.exports = __webpack_public_path__ + "static1710991110236-0.0.5.6/img/page_background-button-C@2x.349ed90c.png";